import React, {useEffect, useState} from "react";
import { useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import configVars from "../../config";
import { Link } from "react-router-dom";
import { getWithExpiry, setWithExpiry } from '../../common';

const AllOrganizations = () => {

    const userRoles = useSelector((state) => state?.userdata?.allUserData?.roles);
    const [cookies] = useCookies(["sustainyou_user_jwt"]);

    const [organisations, setOrganisations] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        const savedOrgData = getWithExpiry( 'all_org_data' );

        if ( savedOrgData ) {
            setOrganisations( savedOrgData );
        } else {

            (async () => {

                setLoading( true );

                let userRequestData = new FormData();
                userRequestData.append( 'token', cookies.sustainyou_user_jwt );
    
                const fetchUrl = `${configVars.apiUrl}sustainteams/v1/getallorganisations/`;
    
                try{
    
                    const response = await fetch(
                        fetchUrl,
                        {
                        method: "POST",
                        headers: {
                            Authorization: `Basic ${configVars.auth}`,
                        },
                        body: userRequestData
                        }
                    );
                    
                    const updateResponse = await response.json();
            
                    if ( updateResponse ) {

                        //console.log( updateResponse );
    
                        if ( updateResponse.success === true ) {
                            setOrganisations( updateResponse.data );
                            setWithExpiry( 'all_org_data', updateResponse.data );
    
                        }
    
    
                    }
    
                } catch( error ) {
                    console.log( error );
                    return error;
                }

                setLoading( false );
    
            })()

        }


    }, [cookies.sustainyou_user_jwt]);

    if ( ! Object.values(userRoles).includes("administrator") ) {
        return (
            <div className="px-4 mt-4 organization-inner" style={{ maxWidth: "1200px" }}>
                <div className="alert alert-secondary" role="alert">
                    Du har inte behörighet att komma åt den här sidan
                </div>
            </div>
        )
    }

    return (
        <div className="px-4 mt-4 organization-inner" style={{ maxWidth: "1200px" }}>

            { loading &&
              <div className="d-flex justify-content-center mt-6">
                <div className="spinner-border text-primary" role="status" >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            }
            
            {organisations && organisations.length > 0 &&
                <div className="table-responsive">
                    <table className="table table-sm table-striped table-bordered table-hover align-middle">
                        <thead className="table-light">
                            <tr>
                                <th scope="col" className="text-center">#</th>
                                <th scope="col">Name</th>
                                <th scope="col" className="text-center">Employees</th>
                                <th scope="col" className="text-center">Managers</th>
                                <th scope="col" className="text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            { organisations.map((organisation, index) => {
                                return (
                                    <tr key={index}>
                                        <th scope="row" className="text-center">{ index + 1}</th>
                                        <td>{organisation?.name}</td>
                                        <td className="text-center">{organisation?.employees}</td>
                                        <td className="text-center">{organisation?.managers}</td>
                                        <td className="text-center"><Link to={`/organizations/${organisation?.id}`} className="btn btn-primary btn-sm text-white rounded-pill px-3">Visa</Link></td>
                                    </tr>
                                )
                            })}
                            
                        </tbody>

                    </table>
                </div>
            }
            
        </div>
    )
}

export default AllOrganizations;